/// <reference path="../../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {

    export interface ProductPickerOptions {
        hideProducts?: string;
    }

    import fld = CampaignresultRow.Fields;

    @Serenity.Decorators.registerClass()
    export class CampaignCheckGrid extends NoboxEntityGrid<CampaignresultRow, ProductPickerOptions> {

        protected getColumnsKey() { return CampaignresultColumns.columnsKey; }
        protected getDialogType() { return <any>CampaignresultDialog; }
        protected getIdProperty() { return CampaignresultRow.idProperty; }
        protected getLocalTextPrefix() { return CampaignresultRow.localTextPrefix; }
        protected getService() { return CampaignresultService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: ProductPickerOptions) {
            super(container, options);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected usePager() {
            return false;
        }

        protected getInitialTitle() {
            return null;
        }
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            var processBy = Q.getLookup("Nobox.AccountLookup").itemById;
            var contact = Q.getLookup("Nobox.ContactLookup").itemById;
            var campaign = Q.getLookup("Nobox.CampaignLookup").itemById;
            //var campaign = Q.getLookup("Nobox.CampaignLookup").itemById;
            Q.first(columns, x => x.field == CampaignresultRow.Fields.ProcessBy).format =
                ctx => {
                    if (processBy[ctx.value] != undefined) {
                        return `<a href="javascript:;" class="account-link">${Q.htmlEncode(processBy[ctx.value]["Name"])}</a>`;
                    } else {
                        return "";
                    }
                };
            Q.first(columns, x => x.field == CampaignresultRow.Fields.Campaign).format =
                ctx => {
                    return `<a href="javascript:;" class="campaign-link">${ctx.value}</a>`;
                };
            Q.first(columns, x => x.field == CampaignresultRow.Fields.Contact).format =
                ctx => {
                    return `<a href="javascript:;" class="contact-link">${ctx.value}</a>`;
                };
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("contact-link")) {
                e.preventDefault();
                new LeadDialog().loadByIdAndOpenDialog(item.ContactId);
            } else if (target.hasClass("account-link")) {
                e.preventDefault();
                new AccountDialog().loadByIdAndOpenDialog(item.ProcessBy);
            } else if (target.hasClass("status-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by status");
                var channelFilter = this.findQuickFilter(Serenity.Select2Editor,
                    CampaignresultRow.Fields.Status);
                channelFilter.set_value(`${item.Status}`);
                this.refresh();
            }
        }


        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedAsInt64().map(x => this.view.getItemById(x).ContactId).toString();
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            return true;
        }
    }
}